import React from "react";
import { Play } from "../../Common/SI";
import { PlayBlock } from "../PlayBlock";

export interface ScoreFrequencyChartProps {
	plays: Play[]
}

export const ScoreFrequencyChart = React.memo(function (props: ScoreFrequencyChartProps): JSX.Element {

	const playsByScore: Map<number, Play[]> = new Map()
	let minScore: number | undefined
	let maxScore: number | undefined
	let totalScore: number = 0
	let scoreCount: number = 0

	for (let i = props.plays.length - 1; i >= 0; i--) {
		const play = props.plays[i]
		if (play.score === null) {
			continue
		}

		let plays = playsByScore.get(play.score)
		if (!plays) {
			plays = []
			playsByScore.set(play.score, plays)
		}

		plays.push(play)

		totalScore += play.score
		scoreCount++

		if (minScore === undefined || minScore > play.score) {
			minScore = play.score
		}
		if (maxScore === undefined || maxScore < play.score) {
			maxScore = play.score
		}
	}

	if (minScore !== undefined && maxScore !== undefined) {
		for (let score = minScore; score <= maxScore; score++) {
			if (!playsByScore.has(score)) {
				playsByScore.set(score, [])
			}
		}
	}

	const scores = Array.from(playsByScore.keys())
	scores.sort((a, b) => a - b)

	return (
		<div className="chart score-frequency">
			<div className="histogram">
				{
					scores.map(score => (
						<div className="labeled-column" key={score}>
							<div className="column-label">{score}</div>
							{
								playsByScore.get(score)!.map(play => (
									<PlayBlock key={play.number} play={play} />
								))
							}
						</div>
					))
				}
			</div>
			<div className="histogram-x-axis-label">
				Score {
					!!scoreCount && <React.Fragment>
						(mean {(totalScore / scoreCount).toFixed(1)})
					</React.Fragment>
				}
			</div>
		</div>
	)
})
